module.exports = __webpack_public_path__ + "img/workBg.0d65dc7c.png";